import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';
import useDidMountEffect from 'assets/js/useDidMountEffect';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const ProductTypeModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState({
    productType: '',
    productTypeSeq: 0,
  });
  const [isData, setIsData] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isIdCheck, setIsIdCheck] = useState(false);

  useEffect(() => {
    if (!props.props?.isRegi && !isData) {
      setItem(props.props?.data.item);
      setIsData(true);
      setIsIdCheck(true);
    }
  }, [props]);

  useDidMountEffect(() => {
    if (!props.props?.isRegi && item.productType === props.props?.data.item.productType) {
      setIsIdCheck(true);
    }
  }, [item]);

  const validation = () => {
    const msgArr = ['Product Type required.'];
    const columns = ['productType'];

    for (let i = 0; i < columns.length; i++) {
      if (Common.isEmpty(item[columns[i]])) {
        Common.errorMsg(msgArr[i]);

        return false;
      }
    }

    if (!isIdCheck) {
      Common.errorMsg('Product Type verification required.');

      return false;
    }

    return true;
  };

  const setProductType = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const request = props.props?.isRegi ? Server.sendPost : Server.sendPut;

            request('product/type', item, productTypeSaveCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const productTypeSaveCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  const productTypeCheck = () => {
    if (isIdCheck) return;

    if (Common.isEmpty(item.productType)) {
      Common.errorMsg('Product Type required.');

      return;
    }

    Server.sendGet('product/type/check', {
      productTypeSeq: item?.productTypeSeq,
      productType: item?.productType
    }, productTypeCheckCallback).then();
  };

  const productTypeCheckCallback = res => {
    if (res?.['resultCount'] === 0) {
      setIsIdCheck(true);

      Common.errorMsg('Available.');
    } else {
      Common.errorMsg('Product Type existing.');

      setItem(() => {
        return {
          ...item,
          productType: '',
        }
      });
    }
  };

  return (
    <>
      <CloseBtn onClick={closeModal} />

      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Product type {props.props?.isRegi ? 'Registration' : 'Modify'}</h4>
          </TitHead>
        </Title>
        <ModalForm>
          <FormIn>
            <FormInWrap>
              <label><span>* </span>Product Type</label>
              <FormInput
                style={{ width: 'calc(70% - 10px)' }}
                type='text'
                id='productType'
                name='productType'
                value={item?.productType}
                onChange={e => {
                  setItem(() => {
                    return {
                      ...item,
                      productType: e.target.value,
                    }
                  });
                  setIsIdCheck(false);
                }}
              />
              <Btn
                style={{
                  flex: 'none',
                  width: '15%',
                  fontSize: '16px',
                  background: !isIdCheck ? '#0072b9' : '#a4a4a4'
                }}
                onClick={productTypeCheck}
              >Check</Btn>
            </FormInWrap>
          </FormIn>
          <FormBtn $Btn>
            <Btn onClick={closeModal}>Cancel</Btn>
            <Btn $Color onClick={setProductType}>Submit</Btn>
          </FormBtn>
        </ModalForm>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  padding: 40px;
  width: 700px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: content-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 100%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
      color: red;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default ProductTypeModal;